module.exports = ['$rootScope', '$window', '$location', '$cookies', '$translate', function($rootScope, $window, $location, $cookies, $translate) {
  // check if userinfo is provided through localstorage or cookies,
  // set it to ls, delete it from cookies
  var userInfo = $window.localStorage.userInfo;

  var jsonUserInfo;
  try {jsonUserInfo = JSON.parse(userInfo);}
  catch(e) {}

  if (!userInfo || !jsonUserInfo) userInfo = $cookies.get('userInfo');

  if($cookies.get('userInfo')) {
    $cookies.remove('userInfo', {domain: '.brandedbridgeline.com'});
  }

  if(userInfo) {
    $window.localStorage.setItem('userInfo', userInfo);
  }

  //
  $rootScope.$on('$routeChangeStart',function(angularEvent, next) {
    $rootScope.onLoginLayout = next.$$route !== undefined && next.$$route.loginLayout !== undefined && next.$$route.loginLayout;
    $rootScope.onInvitedLayout = next.$$route !== undefined && next.$$route.invitedLayout !== undefined && next.$$route.invitedLayout;
    $rootScope.onParticularBrand = next.$$route !== undefined && next.$$route.particularBrand !== undefined && next.$$route.particularBrand;
  });

  $rootScope.$on('$routeChangeError', function(event, current, previous, eventObj) {
    if(eventObj !== undefined && eventObj.authenticated === false || eventObj.status === 401) {
      // if($location.path().indexOf('logout') > -1){
      //   return $location.path("/");
      // }

      $location.path("/login");
    }
    else if(eventObj !== undefined && eventObj.free_user === false) {
      $location.path("/plans-billing-update");
    }
    else if(eventObj !== undefined && eventObj.paid_user === false) {
      $location.path("/plans-billing");
    }
  });

  // config user locale
  var lang = $location.search().ln;
  if (lang) {
    $translate.use(lang);
    $location.search('ln', null);
  }

  console.info('Detected language:', $translate.use());
  window.chl = $translate.use.bind($translate);
}];



/*****************
 ** WEBPACK FOOTER
 ** ./app/app-run.js
 ** module id = 125
 ** module chunks = 0
 **/